module.exports = __webpack_public_path__ + "img/img_15.b7b59d4b.png";